import { UploadFile } from "antd";

export class PrepaidCommentDTO {
    text: string;
    attachments?: string[]

    constructor(text: string, attachments?: string[]){
        this.text = text;
        this.attachments = attachments;
    }
}